import React from 'react'
import { ClickAwayListener, Popper } from '@mui/material'

import ColourIndicator from '../../Edit/ColourIndicator'
import { DEFAULT_COLORS } from '../helpers'
import { BlockPicker } from 'react-color'

import useStyles from './styles'

const ENTER = 'Enter'

interface AddColorProps {
  saveColor: (val: string) => void
  prevColor?: string
  disabled?: boolean
}
const AddColor: React.FC<AddColorProps> = ({
  saveColor,
  prevColor,
  disabled
}) => {
  const classes = useStyles({ disabled })
  const [color, setColor] = React.useState(
    prevColor ? `#${prevColor.replace('#', '')}` : null
  )
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleSelectColor = e => {
    if (!disabled) {
      setAnchorEl(anchorEl ? null : e.currentTarget)
    }
  }
  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleLogKey = React.useCallback(
    e => {
      if (e.code === ENTER && color) {
        handleClose()
      }
    },
    [handleClose, color]
  )

  const handleColorChange = React.useCallback(
    (color, event) => {
      if (color) {
        if (event.nativeEvent.type === 'input') {
          setColor(color.hex)
          saveColor(color.hex)
        } else {
          setColor(color.hex)
          saveColor(color.hex)
          handleClose()
        }
      }
    },
    [handleClose, saveColor]
  )

  React.useEffect(() => {
    if (!prevColor) {
      setColor(null)
    }
  }, [prevColor])

  React.useEffect(() => {
    if (open) {
      const inputEl = document.querySelector("[id*='rc-editable']")
      if (inputEl) {
        document.addEventListener('keydown', handleLogKey)
      }
    }
    return () => {
      const inputEl = document.querySelector("[id*='rc-editable']")
      if (inputEl) {
        document.removeEventListener('keydown', handleLogKey)
      }
    }
  }, [open, handleLogKey])

  return (
    <>
      <div className={classes.colorBox} onClick={handleSelectColor}>
        <ColourIndicator add colour={color} />
      </div>

      <Popper
        open={open}
        anchorEl={anchorEl}
        style={{ zIndex: '1500' }}
        disablePortal
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div>
            <BlockPicker
              color={color ?? '#F1F1F1'}
              onChange={handleColorChange}
              className={classes.picker}
              colors={DEFAULT_COLORS}
              triangle={'hide'}
            />
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default AddColor
